import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { TOOP_AND_TOOP_META } from "./meta.ts";
import { parseToopAndToopDetailHtml } from "./parser.ts";
import { buildSearchUrl } from "./runtime.ts";

export * from "./meta.ts";
export * from "./parser.ts";
export * from "./runtime.ts";

export const TOOP_AND_TOOP_ADAPTER = defineSoldOnlyAdapter(TOOP_AND_TOOP_META, buildSearchUrl, {
  parseDetailHtml: parseToopAndToopDetailHtml,
});
